export default __webpack_public_path__ + "static/Tolerating-93814ad32de7fa854805f9a6df668d80.jpg";